import React, {useState, useEffect, Fragment, useCallback, useContext} from 'react';
import Layout from "../../../../../../components/sales/layout/layout";
import TableSection from "../../../../../../components/sales/tableSection/tableSection";
import {BaseUrl} from "../../../../../../contexts/baseUrl/baseUrl";
import {Button} from "react-bootstrap";
import Images from "../../../../../../assets/images/imageData";
import localization from "../../../../../../assets/localization/localization";
import ListFilters from "../../../../../../components/sales/ListFilters/ListFilters";

const B2C = ({
                 rcCaseListingRequest,
                 match,
                 rcCaseListingResponse = [],

             }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState()
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);

    useEffect(() => {

        (async () => {
            setIsLoading(true);
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
            setRoleId(window.localStorage.getItem('fusion-role'));
            const data = JSON.parse(window.localStorage?.rc_b2c_filter || "{}");
            await rcCaseListingRequest(1, 'LOAN_B2C', data);
            setIsLoading(false);
        })();

    }, []);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headers = [
        'Vehicle No',
        'Channel Name',
        'Customer Name',
        'Loan Type',
        'Case Id',
        'Current RTO State',
        'Created At',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        const data = JSON.parse(window.localStorage?.rc_b2c_filter || "{}");
        await rcCaseListingRequest(val.selected + 1, 'LOAN_B2C', data);
        setIsLoading(false);
    };

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem('rc_b2c_filter', JSON.stringify(filterData));
        setFilterData(filterData);
        await rcCaseListingRequest(1, 'LOAN_B2C', filterData)
        setIsLoading(false);
        filterToggle();
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>

                </Fragment>
            </>
        );
    }

    useEffect(() => {
        setListData();
        if (rcCaseListingResponse && rcCaseListingResponse?.data &&
            rcCaseListingResponse?.data && rcCaseListingResponse?.data?.listing.length > 0) {
            const tableData = ['id', 'vehicle_number', 'channel_name', 'customer_name', 'loan_type', 'loan_id', 'current_state', 'current_state', 'created_at'];
            const data = rcCaseListingResponse?.data?.listing.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {
                        Action: [
                            {
                                name: 'View Details',
                                link: `${baseUrl}/ucd/rc-case-view/${element['loan_id']}/${element['application_id']}`
                            },
                            {
                                name: 'Documents',
                                link: `${baseUrl}/ucd/rc-documents/${element['loan_id']}/${element['application_id']}`
                            },
                        ]
                    }
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(rcCaseListingResponse?.total / rcCaseListingResponse?.per_page));
        }
    }, [rcCaseListingResponse]);


    return (
        <>
            <Layout
                title={"B2C Case"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={rcCaseListingResponse?.data?.listing}
                    srNo={rcCaseListingResponse?.from}
                />
                <ListFilters
                    showFilter={showFilter}
                    filterToggle={filterToggle}
                    applyFilter={(val) => applyFilter(val)}
                    rcCasesFilter={true}
                    listFilterData={rcCaseListingResponse?.data?.filters}
                    localstorageKey={'rc_b2c_filter'}
                />
            </Layout>
        </>
    )
};

export default B2C;
